var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useRef } from 'react';
import { Box, Icon, Optional } from '@honda-canada/design-system-react';
import Context from './service/Context';
import { IconButton, IconContainer, ThreeSixtyInViewContainer, IconContainerAlt, themeStyles, } from './ExteriorView.styles';
import { useLanguage } from '../../utils/sitecoreContext';
import gtmForGenericBapEvent from '../../core/gtm/gtmForGenericBapEvent';
var ImageContainer = themeStyles.apply(Box, 'ImageContainer');
export var ThreeSixtyAnimatedLoader = function (_a) {
    var isVisible = _a.isVisible;
    return (React.createElement(IconContainer, { isVisible: isVisible, "data-testid": "cy-animated360Loader-icon" },
        React.createElement(Icon, { name: "animated360Loader" })));
};
var ThreeSixtyContainer = function (_a) {
    var children = _a.children, gtmVehicleData = _a.gtmVehicleData, height = _a.height, hideRotatingIcon = _a.hideRotatingIcon, iconSize = _a.iconSize, is360EnableVisible = _a.is360EnableVisible, isImageLoading = _a.isImageLoading;
    var _b = useContext(Context), is360Mode = _b.is360Mode, useThreeSixtyAltIcon = _b.useThreeSixtyAltIcon, threeSixtyImageHeight = _b.threeSixtyImageHeight, activate360Mode = _b.activate360Mode;
    var firstTouch = useRef(true);
    var language = useLanguage();
    var ariaLabel = language === 'en' ? 'Click and drag button for 360 view' : 'Bouton cliquer et faire glisser pour une vue � 360';
    var gtmBapEventHandler = function () {
        if (firstTouch.current) {
            gtmForGenericBapEvent(__assign({ eventName: 'thumbnail_360' }, gtmVehicleData));
        }
        firstTouch.current = false;
    };
    return (React.createElement(ImageContainer, { onClick: gtmBapEventHandler, height: height, threeSixtyImageHeight: threeSixtyImageHeight },
        children,
        React.createElement(IconContainer, { isVisible: is360EnableVisible },
            React.createElement(IconButton, { onClick: activate360Mode, "aria-label": ariaLabel, alt: ariaLabel },
                React.createElement(Optional, { when: useThreeSixtyAltIcon },
                    React.createElement(Icon, { name: "threeSixtyAlt", iconSize: "large" })),
                React.createElement(Optional, { when: !useThreeSixtyAltIcon },
                    React.createElement(Icon, { name: "clickAndDrag", iconSize: iconSize, lang: language })))),
        React.createElement(IconContainerAlt, { isVisible: is360Mode && !is360EnableVisible && useThreeSixtyAltIcon && !hideRotatingIcon },
            React.createElement(Icon, { name: "threeSixtyAlt", iconSize: "large" })),
        React.createElement(ThreeSixtyAnimatedLoader, { isVisible: isImageLoading }),
        React.createElement(Optional, { when: is360Mode && !useThreeSixtyAltIcon },
            React.createElement(ThreeSixtyInViewContainer, null,
                React.createElement(Icon, { name: "threeSixtyButton", iconSize: iconSize })))));
};
export default ThreeSixtyContainer;
